module.exports = __webpack_public_path__ + "static/media/running-free.eb816fe3.jpg";